var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#737373"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#F5F5F5",
    strokeWidth: 4.66667
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_11230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.444 17L23.8799 12.5641C24.0401 12.4039 24.0401 12.1442 23.8799 11.984L22.016 10.1201C21.8558 9.95996 21.5961 9.95996 21.436 10.1201L17 14.5561L12.5641 10.1201C12.4039 9.95996 12.1442 9.95996 11.984 10.1201L10.1201 11.984C9.95996 12.1442 9.95996 12.4039 10.1201 12.5641L14.5561 17L10.1201 21.4359C9.95996 21.5961 9.95996 21.8558 10.1201 22.016L11.984 23.8799C12.1442 24.04 12.4039 24.04 12.5641 23.8799L17 19.444L21.4359 23.8799C21.5961 24.0401 21.8558 24.0401 22.016 23.8799L23.8799 22.016C24.04 21.8558 24.04 21.5961 23.8799 21.4359L19.444 17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_11230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivity);
export default __webpack_public_path__ + "static/media/inactivity.c54b5ea8f306965b74ea72149a66342b.svg";
export { ForwardRef as ReactComponent };